module.exports = __webpack_public_path__ + "img/randabstand-EC2-draufsicht.36c0dea0.svg";